import { httpClient } from '../utils';
import { CLASSTING_CLASSTALK_APIS_URL } from '../constants';

export const fetchClasstalkUser = (userId) => httpClient.get(`${CLASSTING_CLASSTALK_APIS_URL}/users/${userId}`);

export const registerClasstalkUser = () => httpClient.post(`${CLASSTING_CLASSTALK_APIS_URL}/register`, {});
